export default {
  gutter: Number,

  grids: Number,

  autoHeight: {
    type: Boolean,
    default: false,
  },

  labelWidth: [String, Number],

  labelAlign: String,

  labelPosition: String,

  itemHeight: Number,

  size: String,

  readonly: {
    type: [Object, Boolean],
    default: undefined,
  },
}
